module.exports = __webpack_public_path__ + "static/media/hoang.ee4350af.png";